import React from "react";
import { Form, Input, Button, Row, Col, Upload } from "antd";

const { TextArea } = Input;

export const EditorMessage = ({ onChange, onSubmit, submitting, value }) => {
    const fileProps = {
        onRemove: (file) => {
            const fileList = value.fileList;
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            onChange({
                ...value,
                fileList: newFileList,
            });
        },
        beforeUpload: (file) => {
            onChange({
                ...value,
                fileList: value.fileList ? [...value.fileList, file] : [file],
            });
            return false;
        },
        fileList: value ? value.fileList : [],
    };

    return (
        <Row type="flex" justify="space-between">
            <Col span={24}>
                <Form.Item>
                    <TextArea
                        rows={3}
                        onChange={(e) =>
                            onChange({
                                ...value,
                                message: e.target.value,
                            })
                        }
                        value={value.message}
                    />
                </Form.Item>
            </Col>
            <Col span={6}>
                <Form.Item>
                    <Upload {...fileProps} multiple>
                        <Button>Selecionar Ficheiros</Button>
                    </Upload>
                </Form.Item>
            </Col>

            <Col span={4}>
                <Form.Item>
                    <Button icon="mail" htmlType="submit" type="primary" loading={submitting} onClick={onSubmit} block>
                        Enviar
                    </Button>
                </Form.Item>
            </Col>
        </Row>
    );
};
